// src/redux/stockData/edgar/edgarAPI.js
import apiClient from "../../authentication/utils/core/axios";

/**
 * Enforces safe query formatting.
 * Prevents `[object Object]` from ever leaking to backend.
 */
function normalizeQuery(input) {
  if (!input) return "";
  if (typeof input === "string") return input.trim().toUpperCase();
  if (typeof input === "number") return String(input);
  return "";
}

const edgarApi = {

  /**
   * Generic EDGAR search (with AI summaries).
   * Accepts a company name or ticker.
   */
  async searchCompanies(query, limit = 10) {
    const q = normalizeQuery(query);

    const response = await apiClient.get(
      "/edgar/search-with-summaries",
      {
        params: { query: q, limit },
      }
    );

    return response.data;
  },

  /**
   * Primary function used by dashboard.
   */
  async getFilings(ticker, limit = 10) {
    const q = normalizeQuery(ticker);

    const response = await apiClient.get(
      "/edgar/search-with-summaries",
      {
        params: { query: q, limit },
      }
    );

    return response.data;
  },

  /**
   * Alias for compatibility.
   */
  async getFilingsByTicker(ticker, limit = 10) {
    return this.getFilings(ticker, limit);
  },

  /**
   * Raw EDGAR search (no summaries).
   */
  async getFilingsRaw(query, limit = 10) {
    const q = normalizeQuery(query);

    const response = await apiClient.get(
      "/edgar/search",
      {
        params: { query: q, limit },
      }
    );

    return response.data;
  },
};

export default edgarApi;
